import React from 'react'
import {Icon} from '@chakra-ui/react'

const RadioIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <path
                d="M20 39C9.52178 39 1 30.4782 1 20C1 9.52178 9.52178 1 20 1C30.4782 1 39 9.52178 39 20C39 30.4782 30.4782 39 20 39ZM20 2.88119C10.5564 2.88119 2.88119 10.5564 2.88119 20C2.88119 29.4436 10.5564 37.1188 20 37.1188C29.4436 37.1188 37.1188 29.4436 37.1188 20C37.1188 10.5564 29.4342 2.88119 20 2.88119Z"
                fill="currentColor"
            />
            <path
                d="M19.9992 29.2648C25.1161 29.2648 29.2641 25.1168 29.2641 20C29.2641 14.8831 25.1161 10.7351 19.9992 10.7351C14.8824 10.7351 10.7344 14.8831 10.7344 20C10.7344 25.1168 14.8824 29.2648 19.9992 29.2648Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default RadioIcon
